import GATSBY_COMPILED_MDX from "/opt/build/repo/src/posts/deploy-to-netlify-from-gatsby-cloud.mdx";
import * as React from 'react';
import {Link} from 'gatsby';
import Layout from '../components/layout';
import SeoHead from '../components/seo-head';
import {GatsbyImage} from "gatsby-plugin-image";
import {useSiteMetadata} from "../hooks/use-site-metadata";
import {MDXProvider} from "@mdx-js/react";
import GoogleAdsense from "../components/google-adsense";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCreativeCommons} from "@fortawesome/free-brands-svg-icons/faCreativeCommons";
import {faCreativeCommonsBy} from "@fortawesome/free-brands-svg-icons/faCreativeCommonsBy";
import {faCreativeCommonsNc} from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNc";
import {faCreativeCommonsNd} from "@fortawesome/free-brands-svg-icons/faCreativeCommonsNd";
import {faArrowLeftLong} from "@fortawesome/free-solid-svg-icons/faArrowLeftLong";
import {faArrowRightLong} from "@fortawesome/free-solid-svg-icons/faArrowRightLong";
import {faFaceGrinWide} from "@fortawesome/free-regular-svg-icons/faFaceGrinWide";
import Toc from "../components/toc";
import BlogSideNav from "../components/blog-side-nav";
import {useMediaQuery} from 'react-responsive';
import PageMeta from "../components/page-meta";
import RssFeedInfo from "../components/rss-feed-info";
import {mdxComponents} from "../components/mdx-components";
const PostPage = ({data, children, pageContext}) => {
  var _data$mdx, _data$mdx$fields, _data$mdx$fields$time, _image$childImageShar, _data$mdx2;
  const {previous, next} = pageContext;
  const {frontmatter} = data.mdx;
  const {subject, title, subtitle, image, tags, createdAt, updatedAt} = frontmatter;
  const readMinutes = Math.ceil((_data$mdx = data.mdx) === null || _data$mdx === void 0 ? void 0 : (_data$mdx$fields = _data$mdx.fields) === null || _data$mdx$fields === void 0 ? void 0 : (_data$mdx$fields$time = _data$mdx$fields.timeToRead) === null || _data$mdx$fields$time === void 0 ? void 0 : _data$mdx$fields$time.minutes);
  const isDesktop = useMediaQuery({
    query: '(min-width: 1024px)'
  });
  return React.createElement(Layout, null, React.createElement("div", {
    className: "flex mx-auto justify-center gap-[100px]"
  }, React.createElement("aside", {
    className: "hidden lg:block w-[300px] shrink-0"
  }, React.createElement(BlogSideNav, {
    subject: subject
  })), React.createElement("article", {
    className: "min-w-0 max-w-none md:max-w-[680px] prose dark:prose-invert"
  }, React.createElement("header", {
    className: "mb-10"
  }, React.createElement("nav", {
    "aria-label": "breadcrumb",
    className: "flex flex-wrap items-center gap-2 text-sm mb-8"
  }, React.createElement(Link, {
    to: '/blog',
    className: "not-hover:text-secondary"
  }, "\uBE14\uB85C\uADF8"), React.createElement("span", {
    className: "text-muted"
  }, '>'), React.createElement(Link, {
    to: `/blog/#${subject.slug}`,
    className: "not-hover:text-secondary"
  }, subject.title)), React.createElement("h1", null, title), subtitle && React.createElement("p", {
    className: "text-xl mb-6 -mt-4"
  }, subtitle), React.createElement(PageMeta, {
    updatedAt: updatedAt,
    readMinutes: readMinutes,
    tags: tags
  })), image && React.createElement(GatsbyImage, {
    class: '-mx-10 mb-10 md:-mx-20',
    image: (_image$childImageShar = image.childImageSharp) === null || _image$childImageShar === void 0 ? void 0 : _image$childImageShar.gatsbyImageData,
    alt: `${title}${subtitle ? ` — ${subtitle}` : ''}`
  }), React.createElement("div", {
    className: "mb-10 print:hidden"
  }, React.createElement(GoogleAdsense, {
    layoutKey: "-f9+5v+4m-d8+7b",
    slot: "9726040265"
  })), React.createElement(MDXProvider, {
    components: mdxComponents
  }, children), React.createElement("div", {
    className: "my-10 print:hidden"
  }, React.createElement(GoogleAdsense, {
    format: "auto",
    slot: "6926754782",
    responsive: true
  })), React.createElement("footer", {
    className: "mt-20"
  }, React.createElement("div", {
    className: "text-xs bg-gray-200 dark:bg-gray-800 mb-20 p-6"
  }, React.createElement("div", {
    className: "text-xl mb-2"
  }, React.createElement(FontAwesomeIcon, {
    className: "cc-icon",
    icon: faCreativeCommons
  }), React.createElement(FontAwesomeIcon, {
    className: "cc-icon",
    icon: faCreativeCommonsBy
  }), React.createElement(FontAwesomeIcon, {
    className: "cc-icon",
    icon: faCreativeCommonsNc
  }), React.createElement(FontAwesomeIcon, {
    className: "cc-icon",
    icon: faCreativeCommonsNd
  })), React.createElement("div", {
    className: "text-secondary"
  }, "\uBE14\uB85C\uADF8 \uAE00\uC758 \uB0B4\uC6A9\uC740 ", React.createElement("a", {
    className: "text-inherit",
    href: "https://creativecommons.org/licenses/by-nc-nd/4.0/deed.ko",
    target: "_blank",
    rel: "nofollow"
  }, "\uD06C\uB9AC\uC5D0\uC774\uD2F0\uBE0C \uCEE4\uBA3C\uC988 \uC800\uC791\uC790\uD45C\uC2DC-\uBE44\uC601\uB9AC-\uBCC0\uACBD\uAE08\uC9C0 4.0 \uAD6D\uC81C \uB77C\uC774\uC120\uC2A4"), "\uC5D0 \uB530\uB77C \uC774\uC6A9\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.")), React.createElement("div", {
    className: "text-lg flex flex-row gap-4 justify-between flex-wrap print:hidden"
  }, previous && React.createElement("div", {
    className: "grow"
  }, React.createElement(Link, {
    to: `/blog/${previous.frontmatter.slug}`
  }, React.createElement("span", {
    className: "text-xl mr-2"
  }, React.createElement(FontAwesomeIcon, {
    icon: faArrowLeftLong
  }), React.createElement(FontAwesomeIcon, {
    icon: faFaceGrinWide
  })), previous.frontmatter.title)), next && React.createElement("div", {
    className: "text-right grow"
  }, React.createElement(Link, {
    to: `/blog/${next.frontmatter.slug}`
  }, next.frontmatter.title, React.createElement("span", {
    className: "text-xl ml-2"
  }, React.createElement(FontAwesomeIcon, {
    icon: faFaceGrinWide
  }), React.createElement(FontAwesomeIcon, {
    icon: faArrowRightLong
  }))))))), React.createElement("aside", {
    className: "hidden 2xl:block w-[280px] shrink-0"
  }, React.createElement("div", {
    className: "sticky top-[130px] h-[calc(100vh-180px)] overflow-y-auto"
  }, React.createElement(Toc, {
    toc: (_data$mdx2 = data.mdx) === null || _data$mdx2 === void 0 ? void 0 : _data$mdx2.tableOfContents,
    title: title
  }), React.createElement(RssFeedInfo, null)))));
};
const query = "888974969";
export const Head = ({data, location}) => {
  var _data$mdx3, _data$mdx3$fields, _data$mdx3$fields$tim;
  const meta = useSiteMetadata();
  const {title, subject, excerpt, image, tags, createdAt, updatedAt} = data.mdx.frontmatter;
  const schema = [{
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: title,
    image: image ? [image.publicURL] : undefined,
    datePublished: createdAt,
    dateModified: updatedAt,
    author: [{
      "@type": "Person",
      name: meta.author,
      url: meta.siteUrl + '/about/'
    }],
    wordCount: (_data$mdx3 = data.mdx) === null || _data$mdx3 === void 0 ? void 0 : (_data$mdx3$fields = _data$mdx3.fields) === null || _data$mdx3$fields === void 0 ? void 0 : (_data$mdx3$fields$tim = _data$mdx3$fields.timeToRead) === null || _data$mdx3$fields$tim === void 0 ? void 0 : _data$mdx3$fields$tim.words,
    keywords: tags || undefined,
    isPartOf: {
      "@type": "Blog",
      name: meta.title + ' 블로그',
      url: meta.siteUrl + '/blog/'
    }
  }, {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [{
      "@type": "ListItem",
      position: 1,
      name: "블로그",
      item: `${meta.siteUrl}/blog/`
    }, {
      "@type": "ListItem",
      position: 2,
      name: subject.title,
      item: `${meta.siteUrl}/blog/#${subject.slug}`
    }, {
      "@type": "ListItem",
      position: 3,
      name: title
    }]
  }];
  return React.createElement(SeoHead, {
    title: title,
    useSiteTitle: true,
    description: excerpt,
    image: image === null || image === void 0 ? void 0 : image.publicURL,
    pathname: location.pathname,
    schema: schema
  });
};
PostPage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PostPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
